<template>
    <div>
        <div class="fullscreen-background">
            <div class="footer button" @click="openUrl('https://qyoucheng.com/ycimages/apk/yc.apk')">点 击 下 载</div>
        </div>
        <div v-show="showTip" id="weixinTip" ref="weixin" class="wxtip">
            <div class="arrow">
                <img src="../assets/arrow.png">
            </div>
            <div class="wxtip-txt">
                请通过浏览器打
                <br />
                开页面进行下载
            </div>
        </div>
    </div>
</template>
<script>

const { userAgent } = navigator
const isWeixin = !!/MicroMessenger/i.test(userAgent)

export default {
    data() {
        return {
            index: 0,
            showTip: false,
        }
    },
    mounted() {
        //window.scrollTo(0, 0);
        if (isWeixin) {
            //如果是微信环境，就弹出遮罩层
            this.showTip = true
        }
    },
    methods: {
        openUrl(url) {
            window.open(url, '_blank');
        }
    }
    // components: {
    //     Header, Footer
    // }
}
</script>
<style scoped lang="less">
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    // width: 90%;
    // background-color: #333;
    // color: white;
    text-align: center;
}

.fullscreen-background {
    background-image: url('../assets/ycdl.jpg');
    background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed;
    /* 背景图片固定 */
    min-height: 100vh;
    width: 100vw;
    /* 至少为视口高度 */
    display: flex;
    align-self: flex-end;
    text-align: center;
}

.content-wrap {
    height: 100%;
    margin: 0;
}

.button {
    font-size: 30px;
    border: 1px solid rgb(151, 201, 235);
    border-radius: 10px;
    // box-shadow: 5px 5px 5px 5px rgba(38, 132, 182, 0.5);
    box-shadow: 0 0 5px 5px hsl(166, 22%, 73%);
    align-self: flex-end;
    text-align: center;
    width: 95%;
    padding: 10px;
    margin: 10px;
    background-color: #21a8c6;
}

.button:hover {
    background-color: #d4f6a3;
}

.button:active {
    background-color: #d4f6a3;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
}

.wxtip {
    background: rgba(0, 0, 0, 0.85);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    text-align: center;
    // justify-content: center;
    align-items: flex-end;
    // img {
    //     width: 100%;
    // }
}

.wxtip-txt {
    border: 1px dashed rgb(224, 230, 234);
    border-radius: 150px;
    margin: 10px 15px;
    padding: 30px;
    color: #fff;
    font-size: 20px;
    line-height: 1.8;

}

.arrow {
    margin-right: 10px;
    display: flex;
    align-items: flex-end;
    align-self: flex-end;
}
</style>